<template>
    <div class="form-table form-table--services form-table--without-scroll">
        <div class="form-table__header j-c--s-b">
            Services
            <span v-if="!is_create" @click="onAdd">Add service</span>
        </div>
        <div class="table-wrap">
            <table class="table table-word-spacing">
                <thead>
                    <th>Type</th>
                    <th>Service</th>
                    <th>Amount,&nbsp;$</th>
                    <th>
                        Kick-off<br />
                        date
                    </th>
                    <th>SOW title</th>
                    <th>Start date</th>
                    <th>Valid to</th>
                    <th>
                        Number<br />
                        of payments
                    </th>
                    <th>Action</th>
                </thead>
                <tbody>
                    <tr v-if="items.length <= 0">
                        <td colspan="9" class="center">No data</td>
                    </tr>
                    <tr v-else v-for="item in items">
                        <td>{{ item.type.name }}</td>
                        <td>
                            <span class="link" @click="onEdit(item.id)">{{
                                item.service.length
                                    ? item.service[0].label
                                    : "-"
                            }}</span>
                        </td>
                        <td>{{ item.amount }}</td>
                        <td>{{ item.kickoff_date }}</td>
                        <td style="white-space: initial">
                            {{ item.sow.name }}
                        </td>
                        <td>{{ item.sow.date }}</td>
                        <td>{{ item.sow.valid_date }}</td>
                        <td>{{ item.num_of_payments }}</td>
                        <td>
                            <a
                                v-if="item.is_legacy"
                                :href="'/sales/createLegacy/' + item.id"
                                style="display: block; margin-bottom: 2px"
                                type="button"
                                >Add first legacy sale</a
                            >
                            <a
                                v-if="[2].includes(item.type.id) && item.status_id !== 5"
                                :href="'/sales/create/' + item.id"
                                style="display: block; margin-bottom: 2px"
                                type="button"
                            >
                                Add Sale
                            </a>
                            <a
                                :href="'/sales/deal-line-items/' + item.id"
                                style="display: block; margin-bottom: 2px"
                                type="button"
                            >
                                View sales
                            </a>
                            <a
                                href="#"
                                style="display: block; margin-bottom: 2px"
                                @click.prevent="deleteService(item.id)"
                                type="button"
                            >
                                Remove
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <deal-service-modal
            v-if="isAdd || editId"
            :editId="editId"
            :editData="editData"
            :onUpdate="handleUpdate"
            :onCreate="handleCreate"
            :deal_id="deal_id"
            :deal_status="deal_status"
            :brand_types="brand_types"
            :services="services"
            :selected_service="selected_service"
            :onClose="handleClose"
            :deal_line_items="items"
            :updateList="updateList"
            :sow_list="sow_list"
            :agency_id="agency_id"
            :id_created_sow="id_created_sow"
            :diminishing="diminishing"
            :deal_period="deal_period"
        ></deal-service-modal>

        <DealSOWModalFromServices
            v-if="isAddSow"
            :deal_id="deal_id"
            :onAdd="addSOWFile"
            :onClose="onCloseSOWModal"
        ></DealSOWModalFromServices>

        <confirm-modal
            v-if="isConfirmOpen"
            :title="'Do you have another deal lineitem?'"
            :onApplyAction="onConfirmApply"
            :onSecondaryAction="onConfirmSecondary"
            :applyLabel="'Yes'"
            :secondaryLabel="'No'"
        ></confirm-modal>

        <confirm-modal
            v-if="isConfirmAddNewSow"
            :title="'Before adding a service, you need to add a SOW'"
            :onApplyAction="onConfirmAddNewSow"
            :applyLabel="'OK'"
        ></confirm-modal>
    </div>
</template>

<script>
import DealServiceModal from "./AddService.vue";
import DealSOWModalFromServices from "../SOWTable/AddSOW.vue";
export default {
    name: "Deal_Services_Table",
    props: [
        "is_create",
        "brand_types",
        "deal_id",
        "deal_status",
        "deal_line_items",
        "services",
        "selected_service",
        "agency_id",
        "diminishing",
        "deal_period",
    ],
    components: {
        DealServiceModal,
        DealSOWModalFromServices,
    },
    created() {
        this.$root.$refs.Deal_Services_Table = this;
    },
    data() {
        return {
            isAdd: false,
            items: [],
            sow_list: [],
            editId: null,
            isConfirmOpen: false,
            isConfirmAddNewSow: false,
            isAddSow: false,
            id_created_sow: null,
        };
    },
    mounted() {
        if (this.deal_id) {
            this.getList();
            this.getSOWList();
        }
    },
    computed: {
        editData() {
            if (this.items.length <= 0) {
                return null;
            }
            let test = this.items.find((item) => item.id === this.editId);
            return test;
        },
    },
    methods: {
        getList() {
            let self = this;
            axios
                .post("/deals/deal-line-items/getList", {
                    deal_id: this.deal_id,
                })
                .then(function (r) {
                    self.items = r.data.items;
                })
                .catch((err) => {
                    console.log("ERROR getList", err);
                });
        },
        updateList(deal_line_items) {
            this.items = deal_line_items;
        },
        onAdd() {
            console.log("onAdd", this.sow_list);

            if (this.sow_list.length <= 0) {
                this.isConfirmAddNewSow = true;
            } else {
                this.isAdd = true;
            }
        },
        onEdit(id) {
            this.getSOWList();
            this.editId = id;
        },

        handleCreate(data) {
            let self = this;

            axios
                .post("/deals/deal-line-items/add", data)
                .then(function (r) {
                    self.updateList(r.data.items);
                    self.handleClose();
                    this.isConfirmOpen = true;
                })
                .catch((err) => {
                    console.log("handleCreate new deal line item error", err);
                    if (err.response) {
                        if (err.response.data) {
                            Object.keys(err.response.data.errors).forEach(
                                (error) => {
                                    this.$toast.error(
                                        err.response.data.errors[error][0] ||
                                            "Error! Something went wrong"
                                    );
                                }
                            );
                        }
                    }
                });
        },

        handleUpdate(data) {
            let self = this;

            axios
                .post("/deals/deal-line-items/update", data)
                .then(function (r) {
                    self.items = r.data.items;
                    self.handleClose();
                })
                .catch((err) => {
                    console.log("ERROR handleUpdate", err);
                });
        },
        deleteService(id) {
            axios.post("/deals/deal-line-items/remove", {
                id: id,
            });
            this.getList();
        },
        handleClose() {
            this.isAdd = false;
            this.editId = null;
        },
        getSOWList() {
            axios
                .post("/deals/sow/getList", {
                    deal_id: this.deal_id,
                })
                .then((response) => {
                    if (response.data.isSuccess) {
                        this.sow_list = response.data.items;
                    }
                })
                .catch((err) => {
                    console.log("ERROR getSOWList", err);
                });
        },

        onConfirmApply() {
            this.isConfirmOpen = false;
            this.onAdd();
        },

        onConfirmSecondary() {
            this.isConfirmOpen = false;
        },

        onConfirmAddNewSow() {
            this.isConfirmAddNewSow = false;
            this.isAddSow = true;
        },

        onCloseSOWModal() {
            this.isAddSow = false;
        },

        // SOW

        addSOWFile(data) {
            axios
                .post("/deals/sow/add", data, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((res) => {
                    this.onCloseSOWModal();

                    if (res.data.items.length) {
                        const new_item_id =
                            res.data.items[res.data.items.length - 1].id;

                        if (new_item_id) {
                            this.id_created_sow = new_item_id;
                            this.sow_list = res.data.items;
                        }
                        this.getSOWList();
                        this.$root.$refs.Deal_SOW_Table.getSOWList();
                        this.onAdd();
                    }
                })
                .catch((err) => {
                    console.log("ERROR addSOWFile", err);
                });
        },
    },
};
</script>
